module.exports = __webpack_public_path__ + "img/Network_Security_Table_JP@4x.118bcaa8.png";